import React from "react";
import StickyFooter from "./StickyFooter";
import Footer, { IFooterProps } from "components/footer/Footer";
import NavigationBar from "components/navigationBar/NavigationBar";
import Toolbar, { ToolbarProps } from "@material-ui/core/Toolbar";
import { transparentColour } from "theme";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    toolbarProps?: ToolbarProps;
    footerProps?: IFooterProps;
}

export default function PageLayout(props: IProps) {
    const { children, toolbarProps = {}, footerProps = {}, ...rest } = props;

    const { style: toolbarStyles, ...toolbarRest } = toolbarProps;

    return (
        <StickyFooter footer={<Footer {...footerProps} />} {...rest}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1",
                }}
            >
                <NavigationBar />
                <Toolbar
                    style={{ backgroundColor: transparentColour, ...toolbarStyles }}
                    {...toolbarRest}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: "1",
                        marginTop: -8,
                        overflow: "hidden",
                    }}
                >
                    {children}
                </div>
            </div>
        </StickyFooter>
    );
}
